import { useContext, useEffect, useState } from "react";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import { IDSSForm } from "../../shared/interfaces/dss.interface";
import Link from "../../components/Link/Link";
import DssCard from "../../components/DssCard/DssCard";
import { DSS_SECTION } from "../../shared/constants";
import { Outlet, useOutlet } from "react-router-dom";
import { routes } from "../../shared/router/routes";
import { DssContext } from "../../shared/providers/dss/dss.provider";

function DSS(props: any) {
    const { translate } = useContext(TranslationContext);
    const { forms } = useContext(DssContext);
    const outlet = useOutlet();

    const [physicalForms, setPhysicalForms] = useState<IDSSForm[]>([]);
    const [mentalForms, setMentalForms] = useState<IDSSForm[]>([]);

    useEffect(() => {
        setMentalForms(forms.filter((form) => form.section === DSS_SECTION.MENTAL));
        setPhysicalForms(forms.filter((form) => form.section === DSS_SECTION.PHYSICAL));
    }, [forms]);

    return (
        <div className="px-1 px-md-31 dss pt-11">
            <div className="d-flex justify-content-start">
                <Link
                    to={outlet ? routes.DSS.path : routes.HOME.path}
                    icon="Chevron--left"
                    iconSize={20}
                    label={translate("common.back", "Back")}
                    customCss="gap-02 text-bd2-rg ms-n1"
                />
            </div>
            <h1 className="text-h2-smbd mt-12 mb-2" id="dss">
                {translate("page.title.decision_support_system", "Decision Support System")}
            </h1>
            {outlet && <Outlet />}
            {!outlet && (
                <div className="d-flex flex-column gap-23 mb-23">
                    {!!mentalForms.length && <section aria-labelledby="title_mental_health">
                        <h2
                            id="title_mental_health"
                            className="d-flex align-items-center gap-02 text-uppercase text-bd2-bd color-blue-500 mb-03">
                            <i className="icon icon-24 icon-neurology" aria-hidden="true" />
                            {translate("dss.mental_health", "Mental health")}
                        </h2>
                        <div className="row g-12">
                            {mentalForms.map((form, i) => (
                                <div className="col-12 col-lg-4" key={i}>
                                    <DssCard form={form} />
                                </div>
                            ))}
                        </div>
                    </section>}
                    {!!physicalForms.length && <section aria-labelledby="title_physical_health">
                        <h2
                            id="title_physical_health"
                            className="d-flex align-items-center gap-02 text-uppercase text-bd2-bd color-blue-500 mb-03">
                            <i className="icon icon-24 icon-neurology" aria-hidden="true" />
                            {translate("dss.physical_health", "Physical health")}
                        </h2>
                        <div className="row g-12">
                            {physicalForms.map((form, i) => (
                                <div className="col-12 col-lg-4" key={i}>
                                    <DssCard form={form} />
                                </div>
                            ))}
                        </div>
                    </section>}
                </div>
            )}
        </div>
    );
}

export default DSS;
